import Vue from 'vue'
import store from 'store'
import qs from 'qs'

export default {
	getInstanceResultsStatistics(rootState, instanceId, mode, callbacks)	{
        let defaultFailErrorCallback = function ()  {
            store.commit('ALERT_DATA_UPDATED', {
                text: "Le calcul des statistiques a échoué.",
                type: 'danger'
            });
        };
		Vue.axios.get(rootState.baseUrl + "/statistics/instance/" + instanceId + "/results/" + mode, {headers: rootState.headers}).then((response) => {
            if (response.data.success)  {
                if (callbacks.success)  {
                    callbacks.success(response.data.data);
                }
                return true;
            }
            if (callbacks.fail)  {
                callbacks.fail();
            }
            defaultFailErrorCallback();
            return false;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            defaultFailErrorCallback();
            return false;
        });
	},
	getInstanceSatisfactionStatistics(rootState, instanceId, mode, callbacks)	{
        let defaultFailErrorCallback = function ()  {
            store.commit('ALERT_DATA_UPDATED', {
                text: "Le calcul des statistiques a échoué.",
                type: 'danger'
            });
        };

		Vue.axios.get(rootState.baseUrl + "/statistics/instance/" + instanceId + "/satisfaction/" + mode, {headers: rootState.headers}).then((response) => {
            if (response.data.success)  {
                if (callbacks.success)  {
                    callbacks.success(response.data.data);
                }
                return true;
            }
            if (callbacks.fail)  {
                callbacks.fail();
            }
            defaultFailErrorCallback();
            return false;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            defaultFailErrorCallback();
            return false;
        });
	},
	getParentTargetInstanceResultsStatistics(rootState, parentTargetInstanceId, callbacks)	{
        let defaultFailErrorCallback = function ()  {
            store.commit('ALERT_DATA_UPDATED', {
                text: "Le calcul des statistiques a échoué.",
                type: 'danger'
            });
        };

		Vue.axios.get(rootState.baseUrl + "/statistics/parent-target-instance/" + parentTargetInstanceId + "/results", {headers: rootState.headers}).then((response) => {
            if (response.data.success)  {
                if (callbacks.success)  {
                    callbacks.success(response.data.data);
                }
                return true;
            }
            if (callbacks.fail)  {
                callbacks.fail();
            }
            defaultFailErrorCallback();
            return false;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            defaultFailErrorCallback();
            return false;
        });
	},
	getParentTargetInstanceSatisfactionStatistics(rootState, parentTargetInstanceId, callbacks)	{
        let defaultFailErrorCallback = function ()  {
            store.commit('ALERT_DATA_UPDATED', {
                text: "Le calcul des statistiques a échoué.",
                type: 'danger'
            });
        };

		Vue.axios.get(rootState.baseUrl + "/statistics/parent-target-instance/" + parentTargetInstanceId + "/satisfaction", {headers: rootState.headers}).then((response) => {
            if (response.data.success)  {
                if (callbacks.success)  {
                    callbacks.success(response.data.data);
                }
                return true;
            }
            if (callbacks.fail)  {
                callbacks.fail();
            }
            defaultFailErrorCallback();
            return false;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            defaultFailErrorCallback();
            return false;
        });
	}
};